import type * as yup from 'yup';

import { nutzSchema } from '@/features/Sparten/nutzv2/schema/schema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const inputSchema = nutzSchema;

export type InputStore = yup.Asserts<typeof inputSchema>;

export const useNutzv2InputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'Nutzv2InputStore',
);
